<template>
<div :style="{ height: `${vh - 170}px` }" class="flex align-items-center justify-content-center pt-3 pb-3">
  <ul  class="flex flex-wrap w-11 md:w-4 list-none p-2 m-2 surface-ground">
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem ">
      <router-link to="/mod-stock/scan-item" class="mr-2 h-full ">
        <PrimevueButton label="Skenovať QR kód" severity="success" icon="pi pi-camera" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/products/0" class="mr-2 h-full">
        <PrimevueButton label="Pridať produkt" severity="success" icon="pi pi-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/boxies/0" class="mr-2 h-full">
        <PrimevueButton label="Pridať krabicu" severity="success" icon="pi pi-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>    
    <li class="flex justify-content-center align-items-center  ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/packages/0" class="mr-2 h-full">
        <PrimevueButton label="Pridať balík" severity="success" icon="pi pi-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/stock-items/0" class="mr-2 h-full">
        <PrimevueButton label="Pridať kus" severity="success" icon="pi pi-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/bulk-add-items" class="mr-2 h-full">
        <PrimevueButton label="Hromadné pridanie kusov" severity="success" icon="pi pi-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/search-items" class="mr-2 h-full">
        <PrimevueButton label="Vyhľadávanie a rezervácia kusov" severity="success" icon="pi pi-search-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/reservation-requests/1" class="mr-2 h-full">
        <PrimevueButton label="Žiadosti o rezervácie" severity="success" icon="pi pi-calendar-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
    <li class="flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem">
      <router-link to="/mod-stock/reservation-requests/2" class="mr-2 h-full">
        <PrimevueButton label="Žiadosti o prestriekanie" severity="success" icon="pi pi-calendar-plus" text raised class="basic-menu uppercase h-full p-2"/>
      </router-link>
    </li>
  </ul>
</div>
</template>

<script lang="ts">

import Security from './security'
import {store} from './store'
import PrimevueButton from 'primevue/button';

export default {
  name: 'StockHome',
  components:{
      PrimevueButton,

  },
  data() {
      return {
      store,
      vh: 0,
    }
  },
    beforeMount() {
      Security.requireToken();

      store.selectModul = this.$route.path.split("/")[1]
      
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
   setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
  },
}    
</script>